import { Box, Typography } from "@mui/material";
import React from "react";
import { ProgressBarSteps } from "../../routes/paid-medical-leave-request/PaidMedicalLeaveRequestModels";
import { ITheme } from "../../utils/theme";
import { progressBarStyle, stepsWrapperStyle } from "./styled";

interface ProgressBarProps {
  steps: string[];
  activeStep: string;
  onStepChange?: (step: ProgressBarSteps) => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  steps,
  activeStep,
  onStepChange,
}) => {
  return (
    <Box sx={progressBarStyle}>
      {steps.map((step, index) => {
        const isCompleted = steps.indexOf(activeStep) >= index;
        return (
          <Box
            key={step}
            onClick={() => onStepChange ? onStepChange(step as ProgressBarSteps) : undefined}
            sx={stepsWrapperStyle(!!onStepChange, steps.length)}
          >
            <Typography
              variant="body2"
              sx={(theme: ITheme) => ({
                marginTop: "4px",
                color: isCompleted ? theme.palette.corporateBlue : theme.palette.offGray,
                fontWeight: isCompleted ? "bold" : "normal",
                textAlign: 'left',
                height: { xs: '56px', sm: 'auto' },
                px: { xs: 1, sm: 0 }
              })}
            >
              {step}
            </Typography>
            <Box
              sx={(theme: ITheme) => ({
                height: "8px",
                backgroundColor: isCompleted ? theme.palette.corporateBlue : theme.palette.coldWhite,
                transition: "background-color 0.3s ease",
                width: '100%'
              })}
            />
          </Box>
        );
      })}
    </Box>
  );
};
